import { useEffect, useState } from "react";
import { Trash2, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { API, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

const FansModeration = () => {
  const [comments, setComments] = useState([]);

  const load = () =>
    API.get("/admin/comments").then(({ data }) => setComments(data)).catch(() => {});

  useEffect(() => {
    load();
  }, []);

  const remove = async (c) => {
    if (!window.confirm(`¿Borrar el comentario de ${c.name}?`)) return;
    try {
      await API.delete(`/admin/comments/${c.id}`);
      toast.success("Comentario eliminado");
      load();
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    }
  };

  return (
    <div className="mt-8 space-y-4" data-testid="fans-moderation">
      {comments.length === 0 ? (
        <div className="py-16 text-center text-slate-500">
          <MessageCircle className="mx-auto mb-3 h-8 w-8 text-slate-600" />
          Todavía no hay comentarios de la afición.
        </div>
      ) : (
        comments.map((c) => (
          <div
            key={c.id}
            className="flex items-start gap-4 rounded-2xl border border-edge bg-ink2 p-4"
            data-testid={`fan-comment-${c.id}`}
          >
            <div className="min-w-0 flex-1">
              <p className="font-display font-bold uppercase text-white">
                {c.name}
                <span className="ml-2 font-mono-score text-[10px] font-normal tracking-widest text-slate-500">
                  {c.created_at?.slice(0, 10)} · {c.slug}
                </span>
              </p>
              <p className="mt-1 text-sm text-slate-300">{c.message}</p>
            </div>
            <Button
              data-testid={`fan-delete-${c.id}`}
              onClick={() => remove(c)}
              className="rounded-full border border-edge bg-transparent text-slate-400 hover:border-crimson hover:text-crimson"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        ))
      )}
    </div>
  );
};

export default FansModeration;
